import { FC } from 'react'

import { Box, CircularProgress, Grid } from '@mui/material'

import { useGET_avatarPartsQuery } from 'redux/api/studentsApi'

interface IAvatarTabProps {
  tabText: string
  tabKey: string
  onClick: any
  disabled?: boolean
}

export const AvatarTab: FC<IAvatarTabProps> = ({ tabText, tabKey, onClick, disabled }) => {
  const {
    isFetching: avatarPartsLoading,
    data: avatarParts,
    error: avatarPartsError,
  } = useGET_avatarPartsQuery({
    page: 1,
    page_size: 50,
    type: tabKey,
  })

  return (
    <Box sx={{ width: '100%' }}>
      {avatarPartsLoading ? (
        <CircularProgress variant='indeterminate' size={20} sx={{ color: '#000' }} />
      ) : (
        <div className='avatar-parts-grid' style={{ width: '100%', alignItems: 'center' }}>
          {avatarParts?.results.map((part, index) => {
            return (
              <div key={index} onClick={() => onClick(part)} className='avatar-parts-item'>
                <div style={{ 
                    width: tabKey === 'face' ? '100%' : '50%',
                    paddingTop: tabKey === 'face' ? '70%' : '100%',
                    margin: 'auto',
                    backgroundImage: `url(${part.file})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat'
                }} />
              </div>
            )
          })}
        </div>
      )}
    </Box>
  )
}
